import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useMediaQueries } from '@honda-canada/design-system-react';
import React from 'react';
import uniqueId from 'lodash/uniqueId';
import { useTranslation } from 'react-i18next';
import { addConfigureBapToastNotification, addGlobalToastNotification } from '../../core/reducers/ui';
import { MY_GARAGE_URL } from '../../utils/constants';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import themeStyles from './CreditAndSignupCtas.styles';
import { useAppDispatch } from '../../core/utils';
import { useSharedApps } from '../../utils/sitecoreContext';
import useBapCtaClickGtm from '../../core/gtm/hooks/useBapCtaClickGtm';
const ToastLink = themeStyles.apply(Link, 'ToastLink');
const MY_GARAGE = 'MyGarage';
const useMyGarageToast = ({ componentName }) => {
    const { t } = useTranslation();
    const { isMobile } = useMediaQueries();
    const dispatch = useAppDispatch();
    const myGarageUrl = useSharedApps(MY_GARAGE_URL);
    const { fireGtmEvent } = useBapCtaClickGtm();
    const addToastNotificationAction = isMobile ? addGlobalToastNotification : addConfigureBapToastNotification;
    const defaultMessage = t('Pages.Bap.updatingBuildToastText', {
        interpolation: { skipOnVariables: true },
    });
    const messageChunks = defaultMessage.split('{{myGarageLink}}');
    function triggerToast(messagePrefix, isGlobal) {
        var _a, _b;
        const id = +uniqueId();
        const message = (_jsxs(_Fragment, { children: [(_a = (messagePrefix || messageChunks[0])) !== null && _a !== void 0 ? _a : '', _jsx(ToastLink, { styling: "tertiaryLight", "data-testid": "cy-ToastLink", as: RoutableSitecoreLink, field: { value: { href: myGarageUrl, linktype: 'external' } }, onClick: () => fireGtmEvent({
                        ctaType: 'click',
                        ctaPlacement: 'notifications',
                        linkText: 'MyGarage',
                        linkUrl: myGarageUrl,
                        componentType: componentName,
                    }), children: MY_GARAGE }), (_b = messageChunks[1]) !== null && _b !== void 0 ? _b : ''] }));
        if (isGlobal)
            return dispatch(addGlobalToastNotification({
                id,
                message,
            }));
        dispatch(addToastNotificationAction({
            id,
            message,
        }));
    }
    return { triggerToast };
};
export default useMyGarageToast;
